export const testimonials = [
  {
    id: 'voice-01',
    name: '许读者',
    role: '关注科技话题 · 使用 8 个月',
    content:
      '以前找入口总是搜到一堆无关页面，现在直接从这里进，分类也很清楚，想看的数码爆料几分钟就能扫完。',
  },
  {
    id: 'voice-02',
    name: '陈同学',
    role: '娱乐话题爱好者 · 使用 5 个月',
    content:
      '我比较在意内容有没有来源说明，这里每条编辑整理都会标注出处和时间，看起来踏实很多，不会一头雾水。',
  },
  {
    id: 'voice-03',
    name: '吴先生',
    role: '财经内容读者 · 使用 1 年',
    content:
      '订阅了每周汇总，一周一封不打扰，重点都帮我挑好了。省下来的时间可以认真读几篇复盘帖。',
  },
];

export const principles = [
  {
    id: 'principle-01',
    icon: 'ri-search-eye-line',
    title: '来源优先',
    desc: '每条内容尽量标注信息来源与时间，把判断权交还给读者，而不是直接下结论。',
  },
  {
    id: 'principle-02',
    icon: 'ri-scales-3-line',
    title: '不做定论',
    desc: '爆料属于未经官方确认的信息，我们只做整理与呈现，不替读者判定真假。',
  },
  {
    id: 'principle-03',
    icon: 'ri-links-line',
    title: '路径清晰',
    desc: '把分散的入口、网址与访问方式归拢到一处，减少无意义的反复搜索。',
  },
  {
    id: 'principle-04',
    icon: 'ri-refresh-line',
    title: '持续更新',
    desc: '热门讨论区与分类内容保持每日维护，过期信息及时标注或下架。',
  },
];

export const stats = [
  { id: 'stat-01', value: '128+', label: '在监话题' },
  { id: 'stat-02', value: '6', label: '主题专区' },
  { id: 'stat-03', value: '每日', label: '内容维护' },
  { id: 'stat-04', value: '每周', label: '更新汇总' },
];